<template>
  <div v-if="hasList">
    <div class="sh-customer">
      <table>
        <slot name="titleComponent"></slot>
        <colgroup>
          <col width="200px"/>
          <col width="*"/>
          <col width="112px">
        </colgroup>
        <tbody>
        <tr v-for="(row, index) in list" :key="index">
          <th scope="row">{{getTypeText(row)}}</th>
          <td>
            <a href="#" @click.prevent="goDetail(row)" v-html="setWordChange(getTitle(row))"></a>
          </td>
          <td>{{regDate(row)}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <slot name="paging"></slot>
  </div>

</template>

<script>
import { setReplaceAll } from '@/common/utils/common'
import _ from 'lodash'

export default {
  name: 'SearchSupportList',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String
    },
    searchWord: {
      type: String
    }
  },
  computed: {
    hasList () {
      return this.list.length > 0
    }
  },
  methods: {
    setWordChange (content) {
      let changeWord = '<span class="col-vari-blue">' + this.searchWord + '</span>'
      return setReplaceAll(content, this.searchWord, changeWord)
    },
    getTypeText (item) {
      let key = ''
      if (this.type === 'faq') {
        key = 'faqtypetext'
      }
      if (this.type === 'notice') {
        key = 'noticetypetext'
      }
      return _.get(item, key, '')
    },
    getTitle (item) {
      let key = ''
      if (this.type === 'faq') {
        key = 'faqtitle'
      }
      if (this.type === 'notice') {
        key = 'noticetitle'
      }
      return _.get(item, key, '')
    },
    regDate (item) {
      return _.get(item, 'regdate', '')
    },
    goDetail (item) {
      const queryParam = {}
      if (this.type === 'faq') {
        queryParam.name = 'faq'
        queryParam.query = {
          faqId: _.get(item, 'faqid', '')
        }
      } else if (this.type === 'notice') {
        queryParam.name = 'notice_view'
        queryParam.query = {
          noticeId: _.get(item, 'noticeid', '')
        }
      }
      this.$router.push(queryParam)
    }
  }
}
</script>
